//Used for web
import * as SentryWeb from '@sentry/browser'
SentryWeb.init({
  dsn:
    'https://4bed262282834f0195a49b3f3c62b6dd@o438798.ingest.sentry.io/5404170',
  ignoreErrors: [/^3000ms timeout exceeded$/],
})

export default SentryWeb
